import { ZIndexOrder } from "@/theme";
import { ActionIcon, Box } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import { MdOutlineMenu } from "react-icons/md";
import { TbCaretLeftFilled } from "react-icons/tb";

export const useSidebarCollapseState = (sidebardId: string) => {
  return useLocalStorage<boolean>({
    key: sidebardId + ":sidebarCollapseState",
    defaultValue: false,
  });
};

export const ShowHideButton = ({
  accordionId = "sidebarAccordion",
}: {
  accordionId?: string;
}) => {
  const [isCollapsed, setState] = useSidebarCollapseState(accordionId);

  return (
    <Box
      pos={"absolute"}
      left={isCollapsed ? 0 : 355}
      top={75}
      style={{
        zIndex: ZIndexOrder.SidbarDisplayToggle,
        cursor: "pointer",
        borderRight: isCollapsed ? "1px solid #BBB" : "none",
        borderTop: isCollapsed ? "1px solid #BBB" : "none",
        borderBottom: isCollapsed ? "1px solid #BBB" : "none",
      }}
      onClick={() => {
        setState(!isCollapsed);
      }}
      bg={isCollapsed ? "#F1F3F5" : "transparent"}
      h={isCollapsed ? "80vh" : 40}
      w={5}
    >
      <ActionIcon
        radius={"xl"}
        autoContrast
        color="gray.4"
        size={"sm"}
        style={{
          border: "1px solid var(--mantine-color-gray-6)",
        }}
      >
        {!isCollapsed ? <TbCaretLeftFilled /> : <MdOutlineMenu />}
      </ActionIcon>
    </Box>
  );
};
